module.exports = __webpack_public_path__ + "img/bannersite.a0c27b50.jpg";